import { graphql, useStaticQuery } from "gatsby"

const AutumnOsloImages = () => {
  const data = useStaticQuery(graphql`
    query {
      img1: file(relativePath: { eq: "blog/autumn-in-osl/img1.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img2: file(relativePath: { eq: "blog/autumn-in-osl/img2.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img3: file(relativePath: { eq: "blog/autumn-in-osl/img3.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img4: file(relativePath: { eq: "blog/autumn-in-osl/img4.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img5: file(relativePath: { eq: "blog/autumn-in-osl/img5.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img6: file(relativePath: { eq: "blog/autumn-in-osl/img6.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img7: file(relativePath: { eq: "blog/autumn-in-osl/img7.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img8: file(relativePath: { eq: "blog/autumn-in-osl/img8.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img9: file(relativePath: { eq: "blog/autumn-in-osl/img9.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img10: file(relativePath: { eq: "blog/autumn-in-osl/img10.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img11: file(relativePath: { eq: "blog/autumn-in-osl/img11.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img12: file(relativePath: { eq: "blog/autumn-in-osl/img12.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img13: file(relativePath: { eq: "blog/autumn-in-osl/img13.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img14: file(relativePath: { eq: "blog/autumn-in-osl/img14.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img15: file(relativePath: { eq: "blog/autumn-in-osl/img15.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img16: file(relativePath: { eq: "blog/autumn-in-osl/img16.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img17: file(relativePath: { eq: "blog/autumn-in-osl/img17.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img18: file(relativePath: { eq: "blog/autumn-in-osl/img18.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img19: file(relativePath: { eq: "blog/autumn-in-osl/img19.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img20: file(relativePath: { eq: "blog/autumn-in-osl/img20.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img21: file(relativePath: { eq: "blog/autumn-in-osl/img21.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img22: file(relativePath: { eq: "blog/autumn-in-osl/img22.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img23: file(relativePath: { eq: "blog/autumn-in-osl/img23.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img24: file(relativePath: { eq: "blog/autumn-in-osl/img24.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img25: file(relativePath: { eq: "blog/autumn-in-osl/img25.JPG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return data
}

export default AutumnOsloImages
